import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { Link as MuiLink } from 'react-router-dom'
import { v4 } from 'uuid'

import { Box, Snackbar } from '@material-ui/core'
import { spacing } from '@material-ui/system'
import MuiAlert from '@material-ui/lab/Alert'

import { urlFor } from '../routes'
import { Base } from '../api/models'
import { AxiosError } from 'axios'
import { isEmpty } from 'lodash'

const Alert = styled(MuiAlert)(spacing)
const Link = styled(MuiLink)(spacing)

type Severity = 'error' | 'warning' | 'info' | 'success'

export interface Message {
  id?: string
  severity?: Severity
  message: string
  obj?: Base
}

const messages: Message[] = []

type Callback = () => void

const callbacks: Callback[] = []

const register = (callback: Callback) => {
  callbacks.push(callback)
}

const deregister = (callback: Callback) => {
  const index = callbacks.indexOf(callback)
  if (index !== -1) {
    callbacks.splice(index, 1)
  }
}

export const sendAlert = (message: Message) => {
  message.id = v4()
  messages.push(message)
  callbacks.map((cb) => cb())
  return message.id
}

const removeMessage = (id: string) => {
  let indexOf = -1
  for (let i = 0; i < messages.length; i++) {
    if (messages[i].id === id) {
      indexOf = i
      break
    }
  }
  if (indexOf !== -1) {
    messages.splice(indexOf, 1)
    callbacks.map((cb) => cb())
  }
}

interface SnackProps {
  message: Message
  handleClose: (id: string) => void
  timeout?: number
}

const Snack = (props: SnackProps) => {
  const { message, handleClose, timeout = 5000 } = props
  useEffect(() => {
    const timeoutID = setTimeout(() => {
      handleClose(message?.id || '')
    }, timeout)
    return () => clearTimeout(timeoutID)
  }, [message, handleClose, timeout])
  return (
    <Alert elevation={6} variant="filled" severity={message.severity || 'info'} mt={1}>
      {message.message}
      {message.obj && (
        <Link to={urlFor(message.obj) as string} ml={2}>
          View
        </Link>
      )}
    </Alert>
  )
}

export const SnackbarHub = () => {
  const [, refresh] = useState({})
  const handleClose = (id: string) => {
    removeMessage(id)
  }
  const open = messages.length !== 0

  useEffect(() => {
    const reg = () => refresh({})
    register(reg)
    return () => deregister(reg)
  }, [])

  return (
    <div>
      <Snackbar
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        open={open}
      >
        {messages && (
          <Box>
            {messages.map((message) => (
              <Snack key={message.id} message={message} handleClose={handleClose} />
            ))}
          </Box>
        )}
      </Snackbar>
    </div>
  )
}

export const handleErrorMessage = (error: AxiosError, action: string, entity: string) => {
  if (error?.response?.data && !isEmpty(error.response.data)) {
    if (error.response.data.details) {
      sendAlert({
        severity: 'error',
        message: `Error ${action}ing Order: ${error.response.data.details}`,
      })
    } else {
      sendAlert({
        severity: 'error',
        message: `Error ${action}ing ${entity}: See inline errors above.`,
      })
    }
  } else if (error?.response?.status === 500) {
    sendAlert({
      severity: 'error',
      message: `Error ${action}ting ${entity}: An unknown error has ocurred`,
    })
  } else {
    sendAlert({
      severity: 'error',
      message: `Error ${action}ting ${entity}: An unknown error has ocurred`,
    })
  }
}
